module.exports = {"full":{"All-instruments":"所有樂器","No-guitar":"沒有吉他"},"details":{"Lesson-Details":"課程詳情","Tablature":"樂譜"}};